import CommonOperationClass from '../../../commonOperationClass';

const one = new CommonOperationClass('1');

export default one;
